export const actionTypes = {
  EMERGENCY_REQUEST_LIST_REQUEST: "EMERGENCY_REQUEST_LIST_REQUEST",
  EMERGENCY_REQUEST_LIST_SUCCESS: "EMERGENCY_REQUEST_LIST_SUCCESS",
  EMERGENCY_REQUEST_LIST_FAILURE: "EMERGENCY_REQUEST_LIST_FAILURE",
  SELECT_USER: "SELECT_USER",
  CREATE_REQUEST_EMERGENCY_USER: "CREATE_REQUEST_EMERGENCY_USER",
  CREATE_REQUEST_EMERGENCY_USER_SUCCESS:
    "CREATE_REQUEST_EMERGENCY_USER_SUCCESS",
  CREATE_REQUEST_EMERGENCY_USER_FAILURE:
    "CREATE_REQUEST_EMERGENCY_USER_FAILURE",
};

export const emergencyRequestListRequest = () => ({
  type: actionTypes.EMERGENCY_REQUEST_LIST_REQUEST,
});

export const emergencyRequestListSuccess = (payload: any) => ({
  type: actionTypes.EMERGENCY_REQUEST_LIST_SUCCESS,
  payload,
});

export const emergencyRequestListFailure = (err: any) => ({
  type: actionTypes.EMERGENCY_REQUEST_LIST_FAILURE,
  err,
});

export const selectUser = (payload: any) => ({
  type: actionTypes.SELECT_USER,
  payload,
});

export const createRequest = (payload: any) => ({
  type: actionTypes.CREATE_REQUEST_EMERGENCY_USER,
  payload,
});

export const createRequestSuccess = (payload: any) => ({
  type: actionTypes.CREATE_REQUEST_EMERGENCY_USER_SUCCESS,
  payload,
});

export const createRequestFailure = (err: any) => ({
  type: actionTypes.CREATE_REQUEST_EMERGENCY_USER_FAILURE,
  err,
});
